import { store } from "../store";
import {
  GROUPS,
  OPEN_CHATS,
  OPEN_PROJECTS,
  RIGHT_TOP,
  SET_CHAT_FULLSCREEN,
  SET_IN_ACTIVITY,
  SET_OPEN_SIDE_BAR,
  SET_TAB,
  TOGGLE_LATEST_MSG,
  TOGGLE_TODO_VIEW,
} from "../store";

/**
 * Navigate to the internal feed and scroll to a specific article.
 *
 * Uses a hard navigation (window.location.assign) because KjuupWA nests two
 * BrowserRouters and keeps chats open via Redux outside the Switch — SPA
 * history.push from a DM often updates the URL bar without leaving the
 * messages layout. A full load of /articles?scrollToArticle=… is reliable,
 * and App.js preserves that deep link on startup/reload.
 */
export function navigateToInternalArticle(history, articleId) {
  if (articleId == null || articleId === "") return;

  const id = String(articleId);
  const target = `/articles?scrollToArticle=${encodeURIComponent(id)}&internal=1`;
  console.log("[ArticleLink] navigating to internal feed", target);

  try {
    store.dispatch({ type: TOGGLE_TODO_VIEW, payload: false });
    store.dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    store.dispatch({ type: SET_CHAT_FULLSCREEN, payload: false });
    store.dispatch({ type: GROUPS, groups: [] });
    store.dispatch({ type: OPEN_CHATS, openChats: [] });
    store.dispatch({ type: OPEN_PROJECTS, openProjects: [] });
    store.dispatch({ type: RIGHT_TOP, rightTop: "" });
    store.dispatch({ type: SET_IN_ACTIVITY, status: false });
    store.dispatch({ type: SET_OPEN_SIDE_BAR, payload: "articles" });
    store.dispatch({ type: SET_TAB, status: 1 });
  } catch (_) {
    /* ignore — hard nav below still works */
  }

  // Hard navigation: bypasses nested-router / chat-layout races.
  window.location.assign(target);
}

export function parseScrollToArticleId(href) {
  if (!href || typeof href !== "string") return null;
  // Lenient match: relative (`/articles?...`), absolute, and entity-encoded
  // (`&amp;`) hrefs.
  const match = href.match(/scrollToArticle=([^&#\s"']+)/i);
  if (match && match[1]) {
    try {
      return decodeURIComponent(match[1]);
    } catch (_) {
      return match[1];
    }
  }
  return null;
}
